import { SpinnerContainer } from './styles'

export const Process = () => {
  return <SpinnerContainer />
}
